/**
 * Simple PDF download fallback using backend API
 * This is used when frontend React-PDF generation fails
 */

export const downloadPDFViaBackend = async (clientInfo, assessmentData) => {
  try {
    console.log('🔄 Utilisation du téléchargement PDF via backend...')
    
    // Call backend API to generate PDF
    const response = await fetch('/api/assessment/download-pdf', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        clientInfo,
        assessmentData
      })
    })

    if (!response.ok) {
      throw new Error(`Erreur backend: ${response.status}`)
    }

    // Download the PDF with proper binary handling
    console.log('📥 Téléchargement de la réponse PDF...')
    const blob = await response.blob()
    console.log('✅ Blob reçu:', blob.size, 'bytes, type:', blob.type)
    
    // Ensure proper PDF blob type
    const pdfBlob = new Blob([blob], { type: 'application/pdf' })
    console.log('✅ PDF Blob créé:', pdfBlob.size, 'bytes')
    
    const url = window.URL.createObjectURL(pdfBlob)
    const a = document.createElement('a')
    a.href = url
    a.download = `CEDEC-Evaluation-${clientInfo.company.replace(/[^a-zA-Z0-9]/g, '-')}-${new Date().getFullYear()}.pdf`
    a.style.display = 'none'
    document.body.appendChild(a)
    
    a.click()
    console.log('✅ Téléchargement backend déclenché')
    
    setTimeout(() => {
      window.URL.revokeObjectURL(url)
      if (document.body.contains(a)) {
        document.body.removeChild(a)
      }
      console.log('✅ Nettoyage backend effectué')
    }, 1000)

    console.log('✅ PDF téléchargé via backend avec succès')
    return true

  } catch (error) {
    console.error('❌ Erreur téléchargement PDF backend:', error)
    throw error
  }
}

/**
 * Generate a simple text-based PDF download as last resort
 */
export const downloadSimpleTextPDF = (clientInfo, assessmentData, recommendations) => {
  console.log('📄 Génération PDF texte simple comme solution de secours...')
  
  const textContent = `
CEDEC - RAPPORT D'AUTO-EVALUATION
================================

Client: ${clientInfo.firstName} ${clientInfo.lastName}
Entreprise: ${clientInfo.company}
Email: ${clientInfo.email}
Date: ${new Date().toLocaleDateString('fr-FR')}

RESULTATS GLOBAUX
================
Score moyen: ${assessmentData.averageScore?.toFixed(1) || 'N/A'}/10
Domaines évalués: ${assessmentData.domains?.length || 0}

SCORES PAR DOMAINE
==================
${assessmentData.domains?.map((domain, index) => {
  const score = Object.values(assessmentData.scores || {})[index] || 0
  return `${domain.name}: ${score}/10`
}).join('\n') || 'Aucun score disponible'}

RECOMMANDATIONS
===============
${recommendations?.strategicRecommendations?.map(rec => 
  `- ${rec.title}: ${rec.description}`
).join('\n') || 'Aucune recommandation disponible'}

PROCHAINES ETAPES
=================
Contactez CEDEC pour un diagnostic personnalisé
Téléphone: 04 67 92 34 00
Email: contact@cedec.eu

Ce rapport a été généré automatiquement par l'outil d'auto-évaluation CEDEC.
Pour un rapport complet avec graphiques, contactez notre équipe.
  `

  // Create and download as text file
  const blob = new Blob([textContent], { type: 'text/plain;charset=utf-8' })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `CEDEC-Evaluation-${clientInfo.company.replace(/[^a-zA-Z0-9]/g, '-')}-${new Date().getFullYear()}.txt`
  a.style.display = 'none'
  document.body.appendChild(a)
  
  a.click()
  
  setTimeout(() => {
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }, 100)

  console.log('✅ Rapport texte téléchargé avec succès')
  return true
}
